import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import styled from 'src/ui/library/styled';
import styles from './styles';
import LinearProgress from '@mui/material/LinearProgress';

const StyledLinearProgress = styled(LinearProgress)({
  root: {
    position: 'absolute',
    right: -1,
    left: -1,
    bottom: -1,
    height: '3px',
  },
  colorPrimary: {
    backgroundColor: 'transparent',
  },
  barColorPrimary: {
    backgroundColor: '#000',
  },
});

class ButtonBase extends React.Component {
  static propTypes = {
    classes: PropTypes.object,
    children: PropTypes.node,
    disabled: PropTypes.bool,
    isLoading: PropTypes.bool,
    noMaxWidth: PropTypes.bool,
    onClick: PropTypes.func,
    className: PropTypes.string,
  };

  static defaultProps = {
    noMaxWidth: false,
    className: '',
  };

  render() {
    const { onClick, disabled, children, classes, className, isLoading, ...otherProps } = this.props;
    const labelClassName = disabled ? classes.labelDisabled : classes.label;
    delete otherProps.noMaxWidth;

    return (
      <Button
        disabled={disabled}
        onClick={onClick}
        fullWidth={true}
        classes={{
          root: classes.root, // class name, e.g. `classes-nesting-root-x`
          disabled: classes.disabled,
        }}
        className={isLoading ? `no-pointer-events ${className}` : className}
        {...otherProps}>
        <span className={labelClassName}>{isLoading ? 'Loading...' : children}</span>
        {isLoading && <StyledLinearProgress variant="indeterminate" />}
      </Button>
    );
  }
}

export { ButtonBase };
export default styled(ButtonBase)(styles);
